import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-maximize-map-with-sidebar-button',
    templateUrl: './maximize-map-with-sidebar-button.component.html',
    styleUrls: ['./maximize-map-with-sidebar-button.component.scss'],
    standalone: false,
})
export class MaximizeMapWithSidebarButtonComponent {
}
